
import { PropTypes } from 'prop-types';
const Purpose = ({ image, purpose, gemCategory, }) => {

    return (
        <div className="flex flex-col items-start w-full gap-5">
            <div className="self-center w-full max-w-[95rem] grid grid-cols-1 place-items-start md:grid-cols-2 gap-8 mb-4">
                <div className="w-full  h-[30rem] bg-center  bg-cover bg-no-repeat" style={{ backgroundImage: `url('${image}')` }} />
                <p className='whitespace-pre-line w-full'>
                {
                    purpose
                }
                </p>
            </div>
            <p className='whitespace-pre-line w-full'>
                {
                    gemCategory
                }
            </p>
        </div>
    )
}
Purpose.propTypes = {
    image: PropTypes.string,
    purpose: PropTypes.string,
    gemCategory: PropTypes.string,
}
export default Purpose